<template>
<v-container fluid class="pa-0">
    <PageHeader :contextStyle="contextStyle">
    </PageHeader>
<!-- Formulaire -->
    <v-card fluid class="ma-2 pa-5 elevation-2">
        <v-layout row wrap>
        <v-flex xs8 class="pa-2">
            <v-text-field label="Nom"  v-model="item.tty_name" :rules="[v => !!v || 'Le nom est obligatoire']"></v-text-field>
        </v-flex>
        <v-flex xs4 class="pa-2">
            <v-checkbox v-model="item.tty_form_plan" :true-value="1" :false-value="0" :label="'Afficher dans: taches à prévoir'"></v-checkbox>
            <v-checkbox v-model="item.tty_form_done" :true-value="1" :false-value="0" :label="'Afficher dans: réalisé'"></v-checkbox>
        </v-flex>
        <v-flex xs12 class="pa-2">
            <v-text-field label="Description"  v-model="item.tty_description" :rules="[v => !!v || 'La description est obligatoire']"></v-text-field>
        </v-flex>
        <v-flex xs6 class="pa-2">
            <v-menu offset-y content-class="elevation-0" style="z-index:900">
                <template v-slot:activator="{ on }">
                    <v-btn :color="item.tty_color" block dark class="mt-3" v-on="on"><v-icon left>mdi-palette</v-icon>Couleur</v-btn>
                </template>
                <v-color-picker v-model="item.tty_color" class="ma-2 elevation-0" hide-canvas :swatches="swatches" show-swatches></v-color-picker>
            </v-menu>
        </v-flex>
        <v-flex xs6 class="pa-2">
            <v-select 
                item-text="sta_label" item-value="sta_id"
                :items="stateListByGroup['GEN']" v-model="item.tty_sta_id" label="Statut" single-line >
            </v-select>
        </v-flex>
        <v-flex xs6 class="pa-2">
            <v-select clearable outlined dense
                :items="quizList" item-text="qiz_name" item-value="qiz_id"
                v-model="item.qiz_id" label="Ligne de quiz associée (non obligatoire)">
            </v-select>
        </v-flex>
        </v-layout>
    </v-card>
    <v-toolbar extended flat color="transparent" class="elevation-0" >
        <v-btn rounded color="error" @click.native="deleteForm()"><v-icon left dark>mdi-close</v-icon>Supprimer</v-btn>
        <v-spacer></v-spacer>
        <v-btn rounded text :to="{ name: 'tasktypes-list' }"><v-icon left dark>mdi-close</v-icon>Annuler</v-btn>
            <v-btn rounded color="success" class="ml-3" :loading="saveProgress" @click.native="saveForm()" :disabled="saveProgress || !isFormValid">
            <v-icon left dark>mdi-content-save-outline</v-icon>Enregistrer
        </v-btn>
    </v-toolbar>
</v-container>
</template>

<script>
import PageHeader from '@/components/ui/PageHeader'

import { mapState, mapWritableState, mapActions } from 'pinia'
import { useTaskTypeStore } from '@/stores/tasktype'
import { useTypeStore } from '@/stores/type'
import { useStateStore } from '@/stores/state'
import { useQuizStore } from '@/stores/quiz'

export default {
    name: 'TaskType-Edit',
    props: [ 'contextStyle'],
    mixins: [ ],
    components: { PageHeader },
    computed: {
        ...mapWritableState(useTaskTypeStore, {item: 'item' }),
        ...mapState(useTypeStore, {typeListByGroup: 'itemListByGroup', typeListById: 'itemListById' }),
        ...mapState(useStateStore, {stateListByGroup: 'itemListByGroup', stateListById: 'itemListById' }),
        ...mapState(useQuizStore, {quizList: 'itemList' }),
        isFormValid () {
            return this.item.tty_name && this.item.tty_description
        }
    },
    data: function () {
        return {
            saveProgress: false,         // Enregistrement en cours...
            loadingData: true,
            swatches: [
                ['#FF0000', '#AA0000', '#550000'], ['#FFFF00', '#AAAA00', '#555500'], ['#00FF00', '#00AA00', '#005500'],
                ['#00FFFF', '#00AAAA', '#005555'], ['#0000FF', '#0000AA', '#000055'],
            ],
        }
    },
    beforeMount: function(){},
    async mounted(){
        this.fetchQuizzes('?per_page=false&qiz_typ_id=QIZ01')
        if( ( this.$route.params.tty_id ) && this.$route.params.tty_id > 0 ){
            await this.fetchItem(this.$route.params.tty_id)
            this.loadingData = false
        } else {
            this.initItem()
            this.loadingData = false
        }
    },
    methods: {
        ...mapActions(useTaskTypeStore, { fetchItem: 'fetchItem', updateItem: 'updateItem', storeItem: 'storeItem', destroyItem:'destroyItem', initItem: 'RESET_ITEM' }),
        ...mapActions(useQuizStore, { fetchQuizzes: 'fetchItems' }),
        async saveForm () {
            if( this.item.tty_id && this.item.tty_id > 0 ){
                await this.updateItem()
                this.$root.$toast({ color: 'success', text: 'Fiche enregistrée !' })
                this.$router.push({ path: '/tasktypes' })
            } else {
                await this.storeItem()
                this.$root.$toast({ color: 'success', text: 'Fiche enregistrée !' })
                this.$router.push({ path: '/tasktypes' })
            }
        },
        async deleteForm(){
            await this.destroyItem()
            this.$root.$toast({ color: 'success', text: 'Fiche supprimée !' })
            this.$router.push({ path: '/tasktypes' })
        },
    }
}
</script>